import React from 'react';
import TextCell from 'app/components/data-table/TextCell';
import TimestampCell from 'app/components/data-table/TimestampCell';

const transformationLibTableColumns = [
  {
    id: 'name',
    name: 'Module Name',
    selector: row => row.name,
    cell: row => <TextCell bubbleClickEvent text={row.name} />,
    width: '25rem',
    sortable: false,
  },
  {
    id: 'description',
    name: 'Description',
    selector: row => row.description,
    cell: row => <TextCell bubbleClickEvent text={row.description} noWrap />,
    sortable: false,
  },
  {
    id: 'createdAt',
    name: 'Created',
    selector: row => row.createdAt,
    cell: row => <TimestampCell bubbleClickEvent timestamp={row.createdAt} />,
    sortable: true,
    width: '15rem',
  },
];

export default transformationLibTableColumns;
